module.exports = __webpack_public_path__ + "static/img/exploit14.ad6e1b01.png";